import AppUserService from 'src/modules/appUser/appUserService';
import Errors from 'src/modules/shared/error/errors';

const prefix = 'APPUSER_VIEW';

const appUserViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: appUserViewActions.FIND_STARTED,
      });

      const record = await AppUserService.find(id);

      dispatch({
        type: appUserViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: appUserViewActions.FIND_ERROR,
        payload: {
          status: Errors.errorCode(error),
        },
      });
    }
  },
};

export default appUserViewActions;
